import kerela1 from '../../Images/FeaturedDestination/kerela/kerela1.jpg';
import kerela2 from '../../Images/FeaturedDestination/kerela/kerela2.jpg';
import kerela3 from '../../Images/FeaturedDestination/kerela/kerela3.jpg';
import goa1 from '../../Images/FeaturedDestination/Goa/goa1.jpg';
import goa2 from '../../Images/FeaturedDestination/Goa/goa2.jpg';
import goa3 from '../../Images/FeaturedDestination/Goa/goa3.jpg';
import ladakh1 from '../../Images/FeaturedDestination/Ladakh/ladakh1.jpg';
import ladakh2 from '../../Images/FeaturedDestination/Ladakh/ladakh2.jpg';
import ladakh3 from '../../Images/FeaturedDestination/Ladakh/ladakh3.jpg';
import andaman1 from '../../Images/FeaturedDestination/Andaman/andaman1.jpg';
import andaman2 from '../../Images/FeaturedDestination/Andaman/andaman2.jpg';
import andaman3 from '../../Images/FeaturedDestination/Andaman/andaman3.jpg';
import sikkim1 from '../../Images/FeaturedDestination/Sikkim/sikkim1.jpg';
import sikkim2 from '../../Images/FeaturedDestination/Sikkim/sikkim2.jpg';
import sikkim3 from '../../Images/FeaturedDestination/Sikkim/sikkim3.jpg';
import kashmir1 from '../../Images/FeaturedDestination/Kashmir/kashmir1.jpg';
import kashmir2 from '../../Images/FeaturedDestination/Kashmir/kashmir2.jpg';
import kashmir3 from '../../Images/FeaturedDestination/Kashmir/kashmir3.jpg';
import Raj1 from '../../Images/Domestic/Rajasthan/Raj1.jpg';
import Raj2 from '../../Images/Domestic/Rajasthan/Raj2.jpg';
import Raj3 from '../../Images/Domestic/Rajasthan/Raj3.jpg';
import RajWild1 from '../../Images/Domestic/Rajasthan/RajWild1.jpg';
import RajWild2 from '../../Images/Domestic/Rajasthan/RajWild2.jpg';
import RajWild3 from '../../Images/Domestic/Rajasthan/RajWild3.jpg';
import MagRaj1 from '../../Images/Domestic/Rajasthan/MagRaj1.jpg';
import MagRaj2 from '../../Images/Domestic/Rajasthan/MagRaj2.jpg';
import MagRaj3 from '../../Images/Domestic/Rajasthan/MagRaj3.jpg';
import GoldRaj1 from '../../Images/Domestic/Rajasthan/GoldRaj1.jpg';
import GoldRaj2 from '../../Images/Domestic/Rajasthan/GoldRaj2.jpg';
import GoldRaj3 from '../../Images/Domestic/Rajasthan/GoldRaj3.jpg';
import Rajas1 from '../../Images/Domestic/Rajasthan/Rajas1.jpg';
import Rajas2 from '../../Images/Domestic/Rajasthan/Rajas2.jpg';
import Rajas3 from '../../Images/Domestic/Rajasthan/Rajas3.jpg';
import RoyalRaj1 from '../../Images/Domestic/Rajasthan/RoyalRaj1.jpg';
import RoyalRaj2 from '../../Images/Domestic/Rajasthan/RoyalRaj2.jpg';
import RoyalRaj3 from '../../Images/Domestic/Rajasthan/RoyalRaj3.jpg';
import and1 from '../../Images/Domestic/Rajasthan/and1.jpg';
import and2 from '../../Images/Domestic/Rajasthan/and2.jpg';
import and3 from '../../Images/Domestic/Rajasthan/and3.jpg';
import nico1 from '../../Images/Domestic/Rajasthan/nico1.jpg';
import nico2 from '../../Images/Domestic/Rajasthan/nico2.jpg';
import nico3 from '../../Images/Domestic/Rajasthan/nico3.jpg';
import rajasthan1 from '../../Images/FeaturedDestination/Rajasthan/rajasthan1.jpg';
import rajasthan2 from '../../Images/FeaturedDestination/Rajasthan/rajasthan2.jpg';
import rajasthan3 from '../../Images/FeaturedDestination/Rajasthan/rajasthan3.jpg';

const locations = [
  {
    id: "RajasthanBest",
    title: "Best of Rajasthan Tour",
    description: "11-day cultural odyssey across Delhi, Mandawa, Bikaner, Jaisalmer, Jodhpur, Ranakpur, Udaipur, Pushkar, Ajmer, and Jaipur.",
    images: [Raj1,Raj2,Raj3],
    region: "Rajasthan",
    tripDuration: "10 Nights / 11 Days",
    Startpoint: "Delhi",
    Endpoint: "Jaipur",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {
    id: "RajasthanWildlife",
    title: "Best of Wildlife - Rajasthan",
    description: "Explore Sariska, Bharatpur, Ranthambore and Jaipur over 7 days. A haven for nature and wildlife enthusiasts.",
    images: [RajWild1,RajWild2,RajWild3],
    region: "Rajasthan",
    tripDuration: "06 Nights / 07 Days",
    Startpoint: "Delhi",
    Endpoint: "Jaipur",
    features: ["Accommodation", "Safari", "Transport", "Meals", "Guides"]
  },
  {
    id: "GoldenTriangle",
    title: "Golden Triangle Tour",
    description: "Classic 5-day tour covering Delhi, Agra, Fatehpur Sikri, Ranthambore, and Jaipur. A perfect blend of culture and heritage.",
    images: [GoldRaj1,GoldRaj2,GoldRaj3],
    region: "Rajasthan",
    tripDuration: "04 Nights / 05 Days",
    Startpoint: "Delhi",
    Endpoint: "Jaipur",
    features: ["Accommodation", "Transport", "Monument Entry", "Guides"]
  },
  {
    id: "MajesticRajasthan",
    title: "Majestic Rajasthan Tour",
    description: "7-day exploration of Jaipur, Jodhpur, and Udaipur. Palaces, lakes, and vibrant bazaars await.",
    images: [MagRaj1,MagRaj2,MagRaj3],
    region: "Rajasthan",
    tripDuration: "06 Nights / 07 Days",
    Startpoint: "Jaipur",
    Endpoint: "Udaipur",
    features: ["Accommodation", "Guides", "Transport", "Cultural Events"]
  },
  {
    id: "RajasthanAllWay",
    title: "Rajasthan All the Way",
    description: "10-day grand circuit from Delhi to Mount Abu via Jaipur, Ranthambore, Pushkar, and Udaipur.",
    images: [rajasthan1, rajasthan2, rajasthan3],
    region: "Rajasthan",
    tripDuration: "09 Nights / 10 Days",
    Startpoint: "Delhi",
    Endpoint: "Mount Abu",
    features: ["Accommodation", "Transport", "Activities", "Meals"]
  },
  {
    id: "RomanticRajasthan",
    title: "Romantic Rajasthan Tour",
    description: "Perfect 5-day romantic escape to Udaipur, Mount Abu and Chittorgarh, filled with scenic beauty and royal charm.",
    images: [Rajas1,Rajas2,Rajas3],
    region: "Rajasthan",
    tripDuration: "04 Nights / 05 Days",
    Startpoint: "Udaipur",
    Endpoint: "Chittorgarh",
    features: ["Accommodation", "Romantic Dinner", "Sightseeing", "Transport"]
  },
  {
    id: "RoyalRajasthan",
    title: "Royal Rajasthan Tour",
    description: "5-day trip covering Jaipur, Jodhpur, and Jaisalmer – a journey through forts and golden deserts.",
    images: [RoyalRaj1,RoyalRaj2,RoyalRaj3],
    region: "Rajasthan",
    tripDuration: "04 Nights / 05 Days",
    Startpoint: "Jaipur",
    Endpoint: "Jaisalmer",
    features: ["Accommodation", "Camel Safari", "Transport", "Meals"]
  },
  {
    id: "TempleHeritage",
    title: "Temple and Heritage Tour",
    description: "Explore Rajasthan’s ancient temples and rich heritage over a short 4-day spiritual journey.",
    images: [MagRaj1, rajasthan2, GoldRaj1],
    region: "North India",
    tripDuration: "03 Nights / 04 Days",
    Startpoint: "Ajmer Drive to Pushkar",
    Endpoint: "Jaipur",
    features: ["Accommodation", "Temple Visits", "Guides", "Transport"]
  },
  {  
    id: "AndamanNicobar",
    title: "Andaman & Nicobar",
    description: "Explore the emerald islands with serene beaches, historic landmarks, and vibrant marine life.",
    images: [and1, and2, and3],
    region: "Andaman & Nicobar",
    tripDuration: " 04 Nights / 05 Days",
    Startpoint: "Port Blair",
    Endpoint: "Port Blair",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {  
    id: "AndamanNicobarFamily",
    title: "Andaman-Nocobar - Famaily Holiday Package",
    description: "Explore the emerald islands with serene beaches, historic landmarks, and vibrant marine life.",
    images: [nico1, nico2, nico3],
    region: "Andaman & Nicobar",
    tripDuration: "05 Nights / 06 Days",
    Startpoint: "Port Blair",
    Endpoint: "Port Blair",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {  
    id: "Kerala",
    title: "Kerala",
    description: "5-day trip covering Cochin , Munnar , Thekkady ,Alleppey",
    images: [kerela1, kerela2, kerela3],
    region: " Kerala",
    tripDuration: "04 Nights / 05 Days",
    Startpoint: "Cochin",
    Endpoint: "Alleppey",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {  
    id: "KerelaSpecial",
    title: "Kerala Special Holiday Package",
    description: "7-day trip covering  Guruvayur , Munnar , Thekkady , Alleppey , Cochin .  ",
    images: [kerela1, kerela2, kerela3],
    region: " Kerala",
    tripDuration: "06 Nights / 07 Days",
    Startpoint: " Guruvayur",
    Endpoint: " Cochin",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {  
    id: "KeralaBackwaters",
    title: "Mesmerizing Kerala Backwaters Tour Package",
    description: "4-day trip covering  Alleppey - Kumarakom",
    images: [kerela1, kerela2, kerela3],
    region: " Kerala",
    tripDuration: " 03 Nights / 04 Days",
    Startpoint: "Cochin",
    Endpoint: "Alleppey",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
   {
    id: "Sikkim",
    title: "Sikkim Tour",
    description: "A mesmerizing journey through Gangtok-Lachung-Yumthang Valley.",
    images: [sikkim1, sikkim2, sikkim3],
    region: "Sikkim",
    tripDuration: "04 Nights / 05 Days",
    Startpoint: "Gangtok",
    Endpoint: "Gangtok",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {
    id: "GangtokSikkim",
    title: "Gangtok and North Sikkim Tour",
    description: "A mesmerizing journey through Gangtok-North Sikkim.",
    images: [sikkim1, sikkim2, sikkim3],
    region: "Sikkim",
    tripDuration: "06 Nights / 07 Days",
    Startpoint: "Sikkim",
    Endpoint: "Sikkim",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {
    id: "Kashmir",
    title: "Kashmir Summer Package",
    description: "Experience the beauty of Srinagar House Boat (1 N) » Srinagar Hotel (3 N) in this unforgettable 8-day tour.",
    images: [kashmir1, kashmir2, kashmir3],
    region: "Kashmir",
    tripDuration: "04 Nights / 05 Days",
    Startpoint: "Srinagar",
    Endpoint: "Gulmarg",
    features: ["Accommodation", "Shikara Ride", "Sightseeing", "Meals", "Transport"]
  },
  {
    id: "KashmirSecond",
    title: "Kashmir Package",
    description: "Experience the beauty of Srinagar, Sonmarg, Pahalgam, and Gulmarg in this unforgettable 8-day tour.",
    images: [kashmir1, kashmir2, kashmir3],
    region: "Kashmir",
    tripDuration: "07 Nights/08 Days",
    Startpoint: "Srinagar",
    Endpoint: "Gulmarg",
    features: ["Accommodation", "Shikara Ride", "Sightseeing", "Meals", "Transport"]
  },
  {
    id: "GoaTourPackage",
    title: "Vibrant Goa Escape",
    description: "Experience the vibrant beaches, scenic coastline, and lively culture of Goa.",
    images: [goa1, goa2, goa3],
    region: "Goa",
    tripDuration: "04 Nights / 05 Days",
    Startpoint: "Goa",
    Endpoint: "Goa",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {
    id: "GoaFamily",
    title: "Jumbo Goa Family Holiday Package",
    description: "7-Days trip covering North-Goa South-Goa water sports-Island tour-Dudhsagar Waterfalls & spice plantations",
    images: [goa1, goa2, goa3],
    region: "Goa",
    tripDuration: " 06 Nights / 07 Days",
    Startpoint: "Goa",
    Endpoint: "Goa",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {
    id: "LehLadakh",
    title: "Leh Ladakh",
    description: "Discover the breathtaking landscapes, serene monasteries, and adventure-filled experiences in Leh Ladakh.",
    images: [ladakh1, ladakh2, ladakh3],
    region: "Ladakh",
    tripDuration: " 03 Nights / 04 Days",
    Startpoint: "Leh",
    Endpoint: "Leh",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  {
    id: "LehLadakhShades",
    title: "All Shades of Leh Ladakh",
    description: "7-Days covering Leh – Sangnam - Pangong Lake – Khardungla Pass - Nubra - Leh.",
    images: [ladakh1, ladakh2, ladakh3],
    region: "Ladakh",
    tripDuration: "06 Nights / 07 Days",
    Startpoint: "Leh",
    Endpoint: "Leh",
    features: ["Accommodation", "Transport", "Guides Services", "Meals", "Activities"]
  },
  
];

export default locations;